import React from "react";

const StoreCheckbox = ({ brand, checked, updateSelectedBrands}) => {
  return(
    <div className="store-select-checkbox col-sm-4 col-xs-6" >
      <label>
        <input type="checkbox" checked={checked} name={brand.key} onChange={updateSelectedBrands}/> {brand.name}
      </label>
    </div>
  );
};

StoreCheckbox.propTypes = {
  brand: React.PropTypes.shape({
    key: React.PropTypes.string.isRequired,
    name: React.PropTypes.string.isRequired,
  }).isRequired,
  checked: React.PropTypes.bool.isRequired,
  updateSelectedBrands: React.PropTypes.func.isRequired,
};

export default StoreCheckbox;



/** WEBPACK FOOTER **
 ** ./src/components/SettingsForm/StoreCheckbox.js
 **/